import { useState, useEffect } from "react";
import { StatusCodes } from "http-status-codes";
import { errorServiceFactory } from "../services/ErrorServiceImpl";

const errorService = errorServiceFactory();

export function useErrorHandler(errorType: StatusCodes) {
    const [errorKey, setErrorKey] = useState("");

    useEffect(() => {
        errorService.resetErrorResponseSubject();
        errorService.subscribeOnError(errorType, () => {
            setErrorKey(`errors.response.${errorType}`);
        });
        return () => {
            errorService.resetErrorResponseSubject();
        };
    }, [errorType]);

    const resetErrors = () => {
        setErrorKey("");
        errorService.resetErrorResponseSubject();
    };

    const isError = () => {
        return errorService.getStatusFromErrorResponseSubject(errorType);
    };

    return {
        errorKey,
        setErrorKey,
        resetErrors,
        isError,
    };
}
